/*global TTImpersonationStatusEnum */
/*eslint no-undef: "error"*/

import React, { Component }               from 'react';
import { Link, Redirect }                 from 'react-router-dom';
import { Column }  from 'react-virtualized';
import fuzzy                from 'fuzzy';
import $                                  from 'webpack-zepto';
import cx                                 from 'classnames';

import { Page, UserMaintenance as UserMaintenanceComponent } from 'moovila-common';

import Masthead             from '../Masthead';
import ImpersonateUserModal from './ImpersonateUserModal';
import LicenseAssignment    from '../../containers/Admin/LicenseAssignment';
import TransferUser         from '../../containers/Admin/TransferUser';
import UserImport           from '../../containers/Admin/UserImport';

let modifier = false;

class UserMaintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDisabled: false,
      typeahead: '',
    }
    this.onChange       = this.onChange.bind(this);
    this.onKeyDown      = this.onKeyDown.bind(this);
    this.toggleDisabled = this.toggleDisabled.bind(this);
    this.inviteHandler  = this.inviteHandler.bind(this);
    this.deleteHandler  = this.deleteHandler.bind(this);
  }

  componentWillMount() {
    window.scrollTo(0, 0)
    this.props.getEnterpriseRoles(this.props.enterpriseGUID);
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.method !== nextProps.method && this.state.typeahead) {
      this.setState({
        typeahead: '',
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown); 
  }

  onChange(e) {
    const name  = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value,
    });
  }

  onKeyDown(e) {
    if (modifier && e.which === 70) {
      // previous event was modifier and current is F
      e.preventDefault();
      this.typeaheadInput.focus();
    }
    modifier = e.which === 17 || e.which === 91;
  }

  toggleDisabled() {
    this.setState({
      showDisabled: !this.state.showDisabled,
    })
  }

  inviteHandler() {
    this.props.inviteUser(this.props.primaryGUID);
  }

  deleteHandler() {
    const email = this.props.enterpriseUsers.filter((user) => user.primaryGUID === this.props.primaryGUID)[0].userEmailAddress;
    this.props.deleteUser(this.props.primaryGUID, email, this.props.enterpriseUsers);
  }

  render() {
    const {
      enterpriseGUID,
      enterpriseUsers,
      enterprises,
      getEnterpriseUsers,
      licenseID,
      method,
      primaryGUID,
      secondaryGUID,
      setupGlobalImpersonation,
      showMessageBox,
      userInfo,
    } = this.props;

    const activeUsers = enterpriseUsers.filter(user => user.userActive);

    const fuzzyOptions = {
      extract: (el) => `${el.userFirstName} ${el.userLastName} ${el.userDisplayName} ${el.userEmailAddress}`,
    };
    const results = this.state.typeahead.length ? fuzzy.filter(this.state.typeahead, activeUsers, fuzzyOptions) : [];
    const matches = results.sort((a, b) => {
      if (a.score > b.score) {
        return -1;
      } else if (a.score < b.score) {
        return 1;
      } else {
        return 0;
      }
    }).map(r => r.original);

    $('body, html').removeClass('lock-scroll');
    let modal = null;

    // if (method && method !== 'edit' && method !== 'add' && method !== 'invite' && method !== 'delete' && method !== 'remote-assist') {
    // if (method && (method !== 'impersonate' && method !== 'license')) {
    if (method && method !== 'remote-assist' && method !== 'license' && method !== 'import' && method !== 'move') {
      return <Redirect to={`/admin/enterprise-maintenance/users/${enterpriseGUID}`} />;
    }

    if (method === 'remote-assist' && primaryGUID) {
      modal = (
        <ImpersonateUserModal
          enterpriseGUID={enterpriseGUID}
          enterprises={enterprises}
          getEnterpriseUsers={getEnterpriseUsers}
          impersonatedUsers={this.props.impersonatedUsers}
          primaryGUID={primaryGUID}
          setupGlobalImpersonation={setupGlobalImpersonation}
          showMessageBox={showMessageBox}
          userInfo={userInfo}
        />
      );
    }

    if (method === 'license' && primaryGUID) {
      return (
        <LicenseAssignment
          getEnterpriseUsers={getEnterpriseUsers}
          location={this.props.location}
          type='user'
          enterpriseGUID={enterpriseGUID}
          primaryGUID={primaryGUID}
          secondaryGUID={secondaryGUID}
          licenseID={licenseID}
          method={this.props.method}
          context={this.props.context}
          submethod={this.props.submethod}
        />
      );
    }

    const enterprise = enterprises.filter(e => e.enterpriseGUID === enterpriseGUID)[0];
    const enterpriseName = enterprise ? enterprise.enterpriseName : '';

    if (method === 'move' && primaryGUID) {
      return (
        <div className='UserMaintenance--move-user'>
          <TransferUser
            enterprises={enterprises}
            users={enterpriseUsers}
            currentEnterprise={enterprise}
            enterpriseGUID={enterpriseGUID}
            enterpriseName={enterpriseName}
            primaryGUID={primaryGUID}
            secondaryGUID={secondaryGUID}
            method={this.props.method}
            submethod={this.props.submethod}
            showMessageBox={showMessageBox}
            setQuestion={this.props.setQuestion}
            history={this.props.history}
          />
        </div>
      );
    }

    if (method === 'import' && enterpriseGUID) {
      return (
        <UserImport
          enterpriseGUID={enterpriseGUID}
          getEnterpriseUsers={getEnterpriseUsers}
        />
      );
    }


    const footer = null;

    if (modal) {
      $('body, html').addClass('lock-scroll');
    }

    let users = this.state.showDisabled ? enterpriseUsers : activeUsers;
    users = users.sort((a, b) => {
      if (a.userLocked) {
        return -1;
      }
      if (b.userLocked) {
        return 1;
      }
      if (a.userLastName < b.userLastName) {
        return -1;
      }
      if (a.userLastName > b.userLastName) {
        return 1;
      }
      return 0;
    });
    const actions = [
      <Column key='uma-0' width={304} label='' dataKey='userGUID' cellRenderer={() => {}} />,
      <Column
        key='uma-01'
        width={63}
        label='Move'
        dataKey='userGUID'
        cellRenderer={({cellData, rowData}) => {
          const cellClass = cx({
            'btn btn-default btn-block btn-md': true,
          });
          return cellData === null ? '' : 
            <Link to={`/admin/enterprise-maintenance/users/${enterpriseGUID}/move/${cellData}`} className={cellClass}>
              <i className='fa fa-sign-in fa-2x' style={{fontSize: '1.75em', position: 'relative', left: -4}}></i>
            </Link>
        }}
      />,
      <Column
        key='uma-02'
        width={53}
        label='Lic.'
        dataKey='userGUID'
        cellRenderer={({cellData, rowData}) => {
          return cellData === null ? '' : (
            <Link to={`/admin/enterprise-maintenance/users/${enterpriseGUID}/license/${cellData}`} className='btn btn-default btn-block btn-md EnterpriseMaintenance__btn-icon'>
              <i className='fa fa-id-card fa-2x' style={{fontSize: '1.75em', position: 'relative', left: -4}}></i>
            </Link>
          );
        }}
      />,
      <Column
        width={73}
        key='uma-1'
        label='RA'
        dataKey='userGUID'
        cellRenderer={({cellData, rowData}) => {
          const cellClass = cx({
            'btn btn-default btn-block btn-md': true,
            'text-fade cursor-default': !rowData.userActive || !rowData.userConfirmed || rowData.userLocked,
          });

          const iconClass = cx({
            'fa fa-2x': true,
            'fa-user-secret': !this.props.impersonatedUsers ||
                              (
                                this.props.impersonatedUsers &&
                                (
                                  this.props.impersonatedUsers.every(u => u.userGUID !== cellData) ||
                                  (
                                    this.props.impersonatedUsers
                                      .filter(u => u.userGUID === cellData).length && // we do have one
                                    this.props.impersonatedUsers
                                      .filter(u => u.userGUID === cellData)[0].impersonationStatusCode === TTImpersonationStatusEnum.IS_ACTIVE  
                                  )
                                )
                              ),
            'fa-clock-o':     this.props.impersonatedUsers &&
                              this.props.impersonatedUsers
                                .filter(u => u.userGUID === cellData).length && // we have a match
                              this.props.impersonatedUsers
                                .filter(u => u.userGUID === cellData)[0].impersonationStatusCode === TTImpersonationStatusEnum.IS_PENDING,
          })

          const cellStyle = this.props.impersonatedUsers && this.props.impersonatedUsers.some(u => {
            return u.userGUID === rowData.userGUID && u.impersonationStatusCode === TTImpersonationStatusEnum.IS_ACTIVE
          }) ?
            { color: '#343fff' } : { color: '#8b91ff' };

          return (cellData === null ? '' :
            rowData.userActive && rowData.userConfirmed && !rowData.userLocked ? (
              <Link
                to={`/admin/enterprise-maintenance/users/${enterpriseGUID}/remote-assist/${cellData}`}
                className={cellClass}
                style={cellStyle}
                >
                <i className={iconClass}></i>
              </Link>
              // <span className={cellClass}>
              //   <i className={iconClass}></i>
              // </span>
            ) : (
              <span className={cellClass}>
                <i className={iconClass}></i>
              </span>
            )
          );
        }}
      />
    ];

    return (
      <div>
        <Masthead title={`User Maintenance (${enterpriseName})`} icon='fa-user' backTo='/admin/enterprise-maintenance/enterprises' backText='Back to enterprises' />
        <div className='EC-sticky-subheader'>
          <div className='row EC-sticky-subheader-inner'>
            <div className='col-xs-2'>
              <Link to={`/admin/enterprise-maintenance/users/${this.props.enterpriseGUID}/import`} className='btn btn-primary btn-xl btn-margin-fix' id='UserMaintenance_btnAddUser'>
                <i className='fa fa-plus-circle icon' aria-hidden='true'></i>
                Import user
              </Link>
            </div>
            <div className='col-xs-8'>
              <input
                style={{width: '100%', height: 50, padding: '9px 15px', fontSize: 18}}
                type='text'
                name='typeahead'
                val={this.state.typeahead}
                onChange={this.onChange}
                placeholder='Search'
                ref={i => this.typeaheadInput = i}
              />
            </div>
            <div className='col-xs-2'>
            <input
              checked={this.state.showDisabled}
              onChange={this.toggleDisabled}
              className='table-footer__checkbox'
              name='UserMaintenance_chkFilter'
              id='UserMaintenance_chkFilter'
              type='checkbox' />
            <label className='table-footer__label table-footer__label--checkbox' htmlFor='UserMaintenance_chkFilter'>Show disabled</label>
          </div>
          </div>
        </div>
        <Page>
          { users && users.length ?
            <div className='UserMaintenance'>
              { (this.state.typeahead.length && !matches.length) || (users.message && users[0].message === 'ADMIN_ONLY') ?
                <section className='section'>
                  <p><em>{ this.state.typeahead.length ?
                      'No matches to your query.'
                    :
                      'There are currently no users in the system.'
                  }</em></p>
                </section>
              :
                <UserMaintenanceComponent
                  users={this.state.typeahead.length ? matches : users}
                  actions={actions}
                  widths={[45,430,153]}
                />
              }
              { footer }
            </div>
          :
            enterpriseUsers ? (
              <div className='UserMaintenance'>
                { footer }
              </div>
            ) : null
          }
        </Page>
        { modal }
      </div>
    );
  }
}

export default UserMaintenance;



// WEBPACK FOOTER //
// ./src/components/Admin/EnterpriseMaintenanceUsers.js